import type { InferType, ObjectSchema } from 'yup';

export const useFormValidation = <T extends Record<string, unknown>>(
  schema: ObjectSchema<T>,
  onError: (errors: InferType<ObjectSchema<T>>) => void
) => {
  return async (values: T): Promise<boolean> => {
    try {
      await schema.validate(
        { ...values },
        {
          abortEarly: false,
        }
      );
      return true;
    } catch (error) {
      const errors = error.inner.reduce((acc, err) => {
        return { ...acc, [err.path]: err.message };
      }, {});
      onError(errors);
      return false;
    }
  };
};
